import ss from '@/utils/session-storage';

const bikeInformation = {
  namespaced: true,
  state: {
    allBikeInfoList: {
      errorCodeList: ss.getItem('errorCodeList'),
      bikeInfoList: ss.getItem('bikeInfoList'),
      bikeBatteryInfo: ss.getItem('bikeBatteryInfo'),
      bikeSystemInfo: ss.getItem('bikeSystemInfo'),
      bikeUpdatedFwVer: ss.getItem('bikeUpdatedFwVer') // 如有新版本存新版本
    },
    bikeModel: ss.getItem('bikeModel')
  },
  mutations: {
    addErrorCodeList (state, data) {
      ss.setItem('errorCodeList', data);
      state.allBikeInfoList.errorCodeList = ss.getItem('errorCodeList');
    },
    addBikeInfoList (state, data) {
      ss.setItem('bikeInfoList', data);
      state.allBikeInfoList.bikeInfoList = ss.getItem('bikeInfoList');
    },
    addBikeBatteryInfo (state, data) {
      ss.setItem('bikeBatteryInfo', data);
      state.allBikeInfoList.bikeBatteryInfo = ss.getItem('bikeBatteryInfo');
    },
    addBikeSystemInfo (state, data) {
      ss.setItem('bikeSystemInfo', data);
      state.allBikeInfoList.bikeSystemInfo = ss.getItem('bikeSystemInfo');
    },
    addBikeUpdatedFwVer (state, data) {
      ss.setItem('bikeUpdatedFwVer', data);
      state.allBikeInfoList.bikeUpdatedFwVer = ss.getItem('bikeUpdatedFwVer');
    },
    updateBikeSystemInfo (state, data) {
      state.allBikeInfoList.bikeSystemInfo.FwList.forEach(item => {
        if (item.Type === data.Type) {
          item.FwVer = data.LatestFW;
        }
      });
      ss.setItem('bikeSystemInfo', state.allBikeInfoList.bikeSystemInfo);
    },
    addBikeModel (state, data) {
      ss.setItem('bikeModel', data);
      // console.log("TCL: addBikeModel -> data", data)
      state.bikeModel = data;
    }
  },
  actions: {
    addErrorCodeList ({ commit }, data) {
      commit('addErrorCodeList', data);
    },
    addBikeInfoList ({ commit }, data) {
      commit('addBikeInfoList', data);
    },
    addBikeBatteryInfo ({ commit }, data) {
      commit('addBikeBatteryInfo', data);
    },
    addBikeSystemInfo ({ commit }, data) {
      commit('addBikeSystemInfo', data);
    },
    addBikeUpdatedFwVer ({ commit }, data) {
      commit('addBikeUpdatedFwVer', data);
    },
    updateBikeSystemInfo ({ commit }, data) {
      commit('updateBikeSystemInfo', data);
    },
    addBikeModel ({ commit }, data) {
      commit('addBikeModel', data);
    }
  },
  getters: {
    getAllBikeInfoList: state => state.allBikeInfoList,
    getBikeSystemInfo: state => state.allBikeInfoList.bikeSystemInfo,
    getBikeInfoList: state => state.allBikeInfoList.bikeInfoList,
    getBikeModel: state => state.bikeModel
  }
};

export default bikeInformation;
